import { c as _c } from "react/compiler-runtime";
import { useOnClickOutside } from 'react-recipes';
import type { RefObject } from 'react';
export const useOnClickOutsideWithIgnore = (ref, onClickOutside) => {
  const $ = _c(2);
  let t0;
  if ($[0] !== onClickOutside) {
    t0 = e => {
      const target = e.target as HTMLElement;
      if (target?.closest?.("[data-ignore-outside-click]")) {
        return;
      }
      onClickOutside(e);
    };
    $[0] = onClickOutside;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useOnClickOutside(ref, t0);
};